import { getValueOfQueryParam } from './query-params'

export const MODEL_PARAM = 'model'
export const TRIM_PARAM = 'trim'

export interface EntryPresetParams {
	model: string | null
	trim: string | null
}

/**
 * Resolves the shared entry-preset parameters (`?model=` and `?trim=`) from the page URL.
 *
 * These are stable identifiers (VehicleModel.code / TrimModel.code), never display copy, and are
 * meant to preset a vehicle component's initial in-view state on first render. Components consume
 * this resolved object; they do not own deeplink behavior. The same parameters are compatible with
 * the deeplink singleton, e.g. `?gmx-deeplink=exterior&model=envista&trim=4TS58_G04`.
 */
export function getEntryPresetParams(): EntryPresetParams {
	const model = getValueOfQueryParam(MODEL_PARAM)
	const trim = getValueOfQueryParam(TRIM_PARAM)

	return {
		model: model ? model.trim() || null : null,
		trim: trim ? trim.trim() || null : null,
	}
}
